import React from 'react'

import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import { ContentContainer } from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { InteractiveBlockContainer } from 'common/builder/components/chart/FlowChart/components/InteractiveBlockContainer/InteractiveBlockContainer'
import { FlowChartCatalogBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartCatalogBlock'

import * as styles from './Catalog.styles'

export const CatalogBlock: BlockComponent<FlowChartCatalogBlock> = ({ block }) => {
  return (
    <InteractiveBlockContainer id={block.id}>
      <ContentContainer>
        <view style={styles.headerContainerStyle}>
          <richtext text={block.data.header.title} style={styles.headerTextStyle} />
          <richtext text={block.data.header.subtitle} style={styles.headerSubtextStyle} />
        </view>
        {Boolean(block.data.text) && (
          <richtext text={block.data.text} style={styles.bodyTextStyle} />
        )}
        {Boolean(block.data.footer) && (
          <richtext text={block.data.footer} style={styles.footerTextStyle} />
        )}
        <Button button={block.data.button} />
      </ContentContainer>
    </InteractiveBlockContainer>
  )
}
